// @flow

import React from 'react';

type Props = {
  noShadow: boolean,
  className: string,
  noRadius: boolean,
  noPadding: boolean,
  style: Object,
  noBorder: boolean,
  selected: boolean,
  id: any,
  addCheckboxLabel: boolean,
  children?: any
}

const Card = ({
  noShadow, noRadius, noPadding, noBorder, selected, className, children, style, id, addCheckboxLabel
}: Props) => {
  const card = (
    <div
      className={`card
      ${noShadow ? 'no-shadow' : ''} 
      ${noRadius ? 'no-radius' : ''}
      ${noPadding ? 'no-padding' : ''}
      ${noBorder && !selected ? 'no-border' : ''}
      ${selected ? 'is-selected' : ''}
      ${className}`}
      style={style}
    >
      {children}
    </div>
  );
  if (addCheckboxLabel) {
    return (
      <label htmlFor={`card__checkbox-item-${id}`}>
        {card}
      </label>
    );
  }
  return card;
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/shared/Card.js